import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const PoolOutside = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="pool-outside"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.462 35.59h-1.334v-1.333H49.18V38.26a6.493 6.493 0 011.487.008v-21.12c0-1.271-.512-2.494-1.428-3.398a4.94 4.94 0 00-3.47-1.417 4.94 4.94 0 00-3.47 1.417 4.773 4.773 0 00-1.427 3.398v.715h1.487v-.715c0-.903.364-1.766 1.005-2.399l.937.95-.937-.95a3.425 3.425 0 012.405-.984c.899 0 1.764.352 2.405.984a3.369 3.369 0 011.005 2.399v7.48H36.128v-7.481c0-1.27-.511-2.493-1.428-3.397a4.94 4.94 0 00-3.47-1.417 4.94 4.94 0 00-3.469 1.417 4.773 4.773 0 00-1.428 3.398v.715h1.488v-.715c0-.903.363-1.766 1.005-2.399a3.425 3.425 0 012.405-.984c.898 0 1.764.352 2.405.984a3.369 3.369 0 011.005 2.399v21.681a9.41 9.41 0 011.487.437V35.591v0h1.334zm0-2.765h-1.334V26.06H49.18V32.825H37.462z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2.667"
      />
      <path
        d="M54.959 43.759c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.611 2.345-6.844 2.345-9.454 0l-.02-.019-.021-.018c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.61 2.345-6.843 2.345-9.454 0l-.02-.019-.02-.018c-2.611-2.345-6.844-2.345-9.455 0l-.02.018-.02.019A6.799 6.799 0 015 45.206V53h50v-9.204l-.041-.037z"
        fill={fill}
      />
      <circle cx="12.103" cy="12.5" r="3.471" fill={fill} stroke={stroke} />
      <path
        stroke={stroke}
        d="M12.044 20v-1.765M12.044 6.765V5M6.291 8.175L7.727 9.2M17.06 15.868l1.436 1.026M5.78 17.006l1.418-1.051M16.412 9.124l1.418-1.051"
      />
    </svg>
  );
};
/* eslint-enable max-len */

PoolOutside.defaultProps = {
  className: null,
};

PoolOutside.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default PoolOutside;
